<template>
  <div>
    <div class="page-header d-flex w-100">
      <div class="title-col d-flex w-50">
        <span class="title-icon">
          <span class="nt-grid"></span>
        </span>
        <span class="title-text">Dashboard </span>
      </div>
      <div class="text-right ml-auto">
        <!-- <kendo-button @click="addTenant">Add New Tenant</kendo-button> -->
        <kendo-dropdownlist 
          v-if="loadedPage"
          :data-source='getProducts'
          v-model="selectedProd"
          :data-text-field="'code'"
          :data-item-key="'id'"
          :data-value-field="'id'"
          @change="selectedProduct"
          
        >
        </kendo-dropdownlist>
        <!-- <product-select></product-select> -->
      </div>
    </div>
    <div class="page-body">
      <div class="d-flex w-100">
        <div class="w-50">
          <span class="title-text">Tenant Status Overview</span>
        </div>
        <div class="text-right ml-auto">
            <kendo-dropdownlist
              :data-source='getYears'
              v-model="currentYear"
              @change="selectedYear"
              v-if="loadedPage"
            >  
          </kendo-dropdownlist>
        </div>       
      </div>
      <bar-chart v-if="loaded" :dashboardData="passingDataToBarChart"></bar-chart>
    </div>

    <div class="page-body" v-if="selectedProdName == 'ETMS'">
      <div class="d-flex w-100">
        <div class="w-50">
          <span class="title-text">Number of Trips</span>
        </div>
        <div class="text-right ml-auto">
            <kendo-dropdownlist
              :data-source='getYears'
              v-model="currentYear"
              @change="selectedTripYearChange"
              v-if="loadedPage"
            >  
          </kendo-dropdownlist>
            <kendo-dropdownlist v-if="loadedPage && noOfTrips && noOfTrips.length>0"
              :data-source='noOfTrips'
              @change="selectedTenant"
              v-model="tenantId"
              :data-text-field="'tenantName'"
              :data-item-key="'tenantId'"
              :data-value-field="'tenantId'"
            >  
          </kendo-dropdownlist>
        </div>       
      </div>
      <trip-bar-chart v-if="loaded" :selectedTenant="tenantId" :selectedYear="selectedTripYear" :dashboardData = tenantTripsArray></trip-bar-chart>
    </div>


    <div class="new-page-body" v-if="selectedProdName == 'ETMS' || selectedProdName == 'VTS'">
      <div class="d-flex w-100">
        <div class="w-50 p-tblr-1">
          <span class="title-text">Number of 
            <span v-if="selectedProdName == 'ETMS'">Employees</span>
            <span v-if="selectedProdName == 'VTS'">Vehicles</span>
            </span>
        </div>
      </div>
      <pie-chart :width="300" :height="300" v-if="loaded" :selectedProduct="passingDataToPieChart"></pie-chart>
    </div>

  </div>
</template>

<script>
import BarChart from "./BarChart";
import TripBarChart from "./TripBarChart";
import PieChart from "./PieChart";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapMutations, mapGetters } = createNamespacedHelpers("dashboard");
// import { mapActions } from 'vuex';

export default {
  components: {
    BarChart,
    PieChart,
    TripBarChart
  },
  data() {
    return {
      datacollection: null,
      selectedProd: 0,
      selectedYr: this.currentYear,
      loaded: false,
      loadedPage: false,
      selectedProdName: 'VTS',
      tenantId:'',
      selectedTripYear: this.currentYear,
      tenantTripsArray: [],
    };
  },
  
  computed: {
    ...mapState(["dashboard", "prods", "years","currentYear","activatedTenants","noOfTrips"]),
    ...mapMutations(["getTenantDetailsOnYear", "setCurrentYear"]),
    ...mapGetters(["getTenantsByTrips"]),
    getProducts(){
      return this.prods;
    },
    // selectedFacility() {
    //   console.log("Default : ",this.currentYear)
    //   return this.$store.state.products[0];
    // },
    getYears() {
      return this.years;
    },
    passingDataToBarChart() {
      return [
        this.selectedProd, this.selectedYr
      ]
    },
    passingDataToPieChart() {
       return this.selectedProdName;
    },
    passingTenantId() {
      return [this.tenantId, this.selectedTripYear];
    },
  },
  methods: {
    fillData() {

      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()]
          },
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      };
      
    },
    selectedProduct(e){
      this.loaded = false
      this.selectedProdName = e.sender._oldText;
      this.selectedProd = e.sender._cascadedValue;
      if(!this.selectedYr) {
        this.selectedYr = new Date().getFullYear();
      }
      this.getDataOnload();
      this.$mount();
      this.loaded = true
    },
    selectedYear(e) {
      this.loaded = false
      this.selectedYr = e.sender._cascadedValue;
      this.getDataOnload();
      this.$mount();
      this.loaded = true
    },
    selectedTripYearChange(e) {
      this.loaded = false
      this.selectedTripYear = e.sender._cascadedValue;
      this.getDataOnload();
      this.$mount();
      this.loaded = true
    },
    selectedTenant(e) {
      this.loaded = false;
      this.tenantId = e.sender._cascadedValue;
      this.loaded = true;
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    getDataOnload() {
      this.$store.dispatch("dashboard/getProducts");
      this.$store.dispatch("dashboard/getYears");
      if(this.selectedProdName == 'ETMS') {
        let data = {
          productName: this.selectedProdName,
          year: this.selectedTripYear ? this.selectedTripYear : this.currentYear
        }
      this.$store.dispatch("dashboard/getTenantTripDetailsOnProductName", data).then(() => {
        this.tenantId = this.noOfTrips[0].tenantId;
        this.tenantTripsArray = this.noOfTrips;
      });
      }
    },
    
  },
  mounted() {
    this.getDataOnload();
    setTimeout(()=>{this.loaded=true},500)
    setTimeout(()=>{this.loadedPage=true},500)
  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}

.page-body {
  width: 97%;
  background-color: white;
  margin: 10px auto;
  padding: 15px;
}

.p-tblr-1 {
  padding: 1rem;
}

.new-page-body {
  width: 60%;
  margin: 16px;
  height: 450px;
  background-color: white;
}
.k-widget {
  margin-right: 1rem;
}
</style>